// eslint-disable-next-line import/no-anonymous-default-export
export default function (str) {
  return str.match("[0-9+.]*$")[0];
}
